import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Modal,
  Table
} from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';
import AddressForm from './AddressForm';
import { ListAltOutlined, Trop, Clear, Edit } from '@material-ui/icons';
import { maskDocument } from 'helpers/document';
import BootstrapTable from 'react-bootstrap-table-next';
import Unauthorized from 'components/Unauthorized';
import { useCompany, useProfile, useUser } from 'models';
import { formatMoney } from 'helpers/Currency';
import UsersRequestService from 'services/users-request';
import { parseDateBR } from 'helpers/date';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import {
  faPlus,
  faTrophy
} from '@fortawesome/free-solid-svg-icons';

import * as elite from '../../images/logo-elite.png';
import * as scancash from '../../images/scancash.png';
import * as elitePass from '../../images/logo/logo_scansource_select_colorido.png'

export default function () {
  const user = useUser()
  const profile = useProfile()
  const { company: currentCompany } = useCompany()

  const [users, setUsers] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false)
  const [showUserDeleteModal, setShowUserDeleteModal] = useState(false)
  const [userToSave, setUserToSave] = useState({})
  const [userIdToDelete, setUserIdToDelete] = useState(null)

  function showCategory(category) {
    switch (category) {
      case 1: return <img src={elite} className="" alt="elite" height="25" />
      case 2: return "Elite Gerencial"
      case 3: return <img src={scancash} className="" alt="scancash" height="25" />
      case 4: return <img src={elitePass} className="" alt="scancash" height="25" />
      default: return "Sem categoria"
    }
  }

  function getColorTrophy(position) {
    switch (position) {
      case 1: return 'gold'
      case 2: return 'silver'
      case 3: return '#cd7f32'
      default: return 'gray'
    }
  }

  useEffect(() => {
    getUsersByCompany()
  }, [])

  const getUsersByCompany = () => {
    const renderActionsButton = user => {
      return (
        <div>
          <Button
            size="sm"
            variant="outline-info"
            className='mr-2'
            onClick={() => {
              //showSwalForm({ ...user })
              //setShowUserModal(true)
              handleShowUserModal()
              const _user = { ...user }
              _user['action'] = "update"
              setUserToSave(_user)
            }}
          >
            <Edit />
          </Button>
          <Button
            onClick={() => {
              setUserIdToDelete(user.id)
              setShowUserDeleteModal(true)
            }}
            size="sm"
            variant="outline-danger"
          >
            <Clear />
          </Button>
        </div>
      )
    }

    var profiles = [];

    if (currentCompany.is_premium)
      profiles = [...profiles, ...[4, 6, 7]]

    if (currentCompany.is_masteragent)
      profiles = [...profiles, ...[46, 47, 49]]

    UsersRequestService.getByCompany(currentCompany.id, {
      params: {
        __profile_id: profiles.join()
      }
    })
      .then(({ data: response }) => {
        const usersList = response.data.map(user => {
          return {
            id: user.id,
            name: `${user.name} ${user.lastname}`,
            email: user.email,
            created_at: parseDateBR(user.created_at),
            phone: user.phone,
            profile: user.profile.name,
            actions: renderActionsButton(user)
          }
        })
        setUsers(usersList);
      })
  }

  const handleClose = () => {
    Object
      .keys(userToSave)
      .forEach(key => {
        if (key != "company_id")
          userToSave[key] = ""
      })
    setShowUserModal(false)
  };
  const handleShowUserModal = () => setShowUserModal(true);

  const handleDeleteClose = () => setShowUserDeleteModal(false)

  const setValue = (name, value) => {
    let user_aux = { ...userToSave };
    user_aux[name] = value;
    setUserToSave({ ...user_aux });
  }

  const handleSubmitUser = () => {
    var message = ""
    var formData = new FormData()
    formData.append('name', userToSave.name)
    formData.append('lastname', userToSave.lastname)
    formData.append('phone', userToSave.phone ?? "")
    formData.append('alias', userToSave.alias)
    formData.append('profile_id', userToSave.profile_id)
    formData.append('companies[0]', userToSave.company_id)

    var response = null
    if (userToSave.id) {
      message = "Dados Atualizados"
      formData.append('_method', 'put')
      formData.append('id', userToSave.id)
      response = UsersRequestService.update(userToSave.id, formData)
    } else {
      message = "Usuário Cadastrado"
      formData.append('email', userToSave.email)
      response = UsersRequestService.save(formData)
    }

    delete userToSave.action

    response.then(() => {
      setShowUserModal(false)
      getUsersByCompany()
      toast.success(message)
    })
  }
  const handleDeleteUser = () => {
    UsersRequestService.delete(userIdToDelete)
      .then(() => {
        setShowUserDeleteModal(false)
        getUsersByCompany()
      })
  }

  return (
    <Container>
      <Row className="mt-4">
        <ListAltOutlined className="icon-title" />
        <h5 className="title-dashboard">Revenda</h5>
      </Row>
      <Row>
        <Col md="12">
          <Card className="mt-2 shadow bg-white rounded">
            <Card.Body>
              <Row>
                <Col md="12">
                  <h6 className="title-dashboard">Dados cadastrais</h6>
                  <hr className="line"></hr>
                </Col>
                <Col md="12">
                  <Row>
                    <Col md="4">
                      <h4>Classificação:</h4>
                      <p className='h5'>{currentCompany.ranking_position}ª {' '} <FontAwesomeIcon icon={faTrophy} color={getColorTrophy(currentCompany.ranking_position)} /></p>
                    </Col>
                    <Col md="4">
                      <h4>Categoria:</h4>
                      {showCategory(currentCompany.is_premium)}
                    </Col>
                    <Col md="4">
                      <h4>Grupo:</h4>
                      <p>{currentCompany.group_name}</p>
                    </Col>
                    <Col md="4">
                      <h4>Razão Social:</h4>
                      <p>{currentCompany.name}</p>
                    </Col>
                    <Col md="4">
                      <h4>Nome Fantasia:</h4>
                      <p>{currentCompany.company_name}</p>
                    </Col>
                    <Col md="4">
                      <h4>CNPJ:</h4>
                      <p>{maskDocument(currentCompany.document)}</p>
                    </Col>
                    <Col md="4">
                      <h4>Faturamento do Grupo:</h4>
                      <p>{formatMoney(currentCompany.ranking_value)}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col md="12">
          <Card className="mt-2 shadow bg-white rounded">
            <Card.Body>
              <Row>
                <Col md="12" className="d-flex justify-content-between">
                  <h6 className="title-dashboard">Usuários</h6>
                  <Button size='sm' variant="success" onClick={() => handleShowUserModal()}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar Usuário
                  </Button>
                </Col>
                <Col><hr className="line"></hr></Col>
                <Col md="12">
                  <Table striped bordered>
                    <thead>
                      <tr>
                        <th className='text-center'>Nome</th>
                        <th className='text-center'>Email</th>
                        <th className='text-center'>Perfil</th>
                        <th className='text-center'>Data de Cadastro</th>
                        <th className='text-center'>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user) => (
                        <tr key={user.id}>
                          <td className='text-center'>{user.name}</td>
                          <td className='text-center'>{user.email}</td>
                          <td className='text-center'>{user.profile}</td>
                          <td className='text-center'>{user.created_at}</td>
                          <td className='text-center'>{user.actions}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        size='lg'
        backdrop="static"
        keyboard={false}
        centered
        show={showUserModal}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Formulário de Usuário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Nome:</Form.Label>
                  <Form.Control
                    as="input"
                    onChange={(e) => setValue("name", e.target.value)}
                    value={userToSave.name}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Sobrenome:</Form.Label>
                  <Form.Control
                    as="input"
                    onChange={(e) => setValue("lastname", e.target.value)}
                    value={userToSave.lastname}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={userToSave.action}
                    onChange={(e) => setValue("email", e.target.value)}
                    value={userToSave.email}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Telefone:</Form.Label>
                  <Form.Control
                    as="input"
                    onChange={(e) => setValue("phone", e.target.value)}
                    value={userToSave.phone}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Apelido:</Form.Label>
                  <Form.Control
                    as="input"
                    onChange={(e) => setValue("alias", e.target.value)}
                    value={userToSave.alias}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Perfil:</Form.Label>
                  <Form.Control
                    as="select"
                    value={userToSave.profile_id}
                    onChange={(e) => {
                      setValue("profile_id", e.target.value)
                    }}
                  >
                    <option value="" selected disabled>Selecione o Perfil</option>
                    {currentCompany.is_premium ? (<>
                      <option value="4">Revenda Master</option>
                      <option value="7">Revenda Visualizador</option>
                    </>) : (<></>)}
                    {currentCompany.is_masteragent ? (<>
                      <option value="46">Consultor de Negócio</option>
                      <option value="47">Consultor de Negócio</option>
                      <option value="49">Revenda Master Agent</option>
                    </>) : (<></>)}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmitUser}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
          backdrop="static"
          keyboard={false}
          show={showUserDeleteModal}
          onHide={handleClose}
        >
          <Modal.Body>
            <Alert variant="warning" className="text-center">
              Tem certeza que deseja inativar este usuário ?
            </Alert>
          </Modal.Body>
          <Modal.Footer>
            <Button size="sm" variant="secondary" onClick={handleDeleteClose}>
              Cancelar
            </Button>
            <Button size="sm" variant="danger" onClick={handleDeleteUser}>
              Inativar
            </Button>
          </Modal.Footer>
        </Modal>
    </Container>
  )
  /*const Data = [];
   
  const [company, setCompany] = useState({ companies: [] });
  const [users, setUsers] = useState([]);
  const [info, setInfo] = useState({ segment: [], client_type: [], bu: [] });
  const [messageErro, setMessageErro] = useState(false);
  const [hasGroup, setHasGroup] = useState(false);
  const [companyGroupList, setCompanyGroupList] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false)
  const [showUserDeleteModal, setShowUserDeleteModal] = useState(false)
  const [userToSave, setUserToSave] = useState({
    name: "",
    lastname: "",
    email: "",
    profile_id: "",
    phone: "",
    alias: "",
    company_id: currentCompany.id
  })
  const [userIdToDelete, setUserIdToDelete] = useState(null)
  const [newCategory, setNewCategory] = useState(null)
  const [isSaving, setIsSaving] = useState(false)
  const [companyProvidersCategory, setCompanyProvidersCategory] = useState([
    { 
      company_id: "",
      provider_id: "",
      category_id: ""
    }
  ])

  useEffect(() => {
    getUsersByCompany()
    if (currentCompany) {
      let info = ResalesRequestService.getInfoResale();
      info.then(data => {
        setInfo(data.data);
      })
      ResalesRequestService.getResale(currentCompany.id, {
        params: {
          embed: 'ranking,users.profile,providers,providerCategory'
        }
      })
        .then(({ data: response }) => {
          const { data: company } = response
          const { users } = company
          if (company.all_company_fiscal_years.length > 0) {
            const len = company.all_company_fiscal_years.length;
            const { company_group_id } = company.all_company_fiscal_years[len - 1];
            getCompanyGroup(company_group_id)
          }

          setCompanyProvidersCategory(company.providers.map(provider => ({
            company_id: provider.pivot.company_id,
            provider_id: provider.id,
            category_id: company.provider_category.length > 0 ? 
              company.provider_category.filter(p => p.provider_id == provider.id)[0].category_id : 
              ""
          })))

          setCompany(company);
          if (company.ma_category)
            setNewCategory(company.ma_category) //somente masteragent
        });
    } else {
      setMessageErro(true);
    }
  }, []);

  

  const renderActionsButton = user => {
    return (
      <div>
        <Button
          size="sm"
          variant="outline-info"
          className='mr-2'
          onClick={() => {
            setShowUserModal(true)
            const _user = { ...user }
            _user['action'] = "update"
            setUserToSave(_user)
          }}
        >
          <Edit />
        </Button>
        <Button
          onClick={() => {
            setUserIdToDelete(user.id)
            setShowUserDeleteModal(true)
          }}
          size="sm"
          variant="outline-danger"
        >
          <Clear />
        </Button>
      </div>
    )
  }

  const premiumLabel = is_premium => {
    if (is_premium == 1) {
      return "Elite"
    } else if (is_premium == 2) {
      return "Elite Gerencial"
    } else if (is_premium == 3) {
      return "ScanCash"
    }

    return "outros"
  }

  const getCompanyGroup = company_group_id => {
    let request = ResalesRequestService.getCompanyGroup(company_group_id, {
      params: {
        '__fiscal_year': user.fiscal_year.id
      }
    });
    request.then(({ data: response }) => {
      const { data } = response
      setCompanyGroupList(data.map(item => ({
        id: item.id,
        premium: premiumLabel(item.is_premium),
        name: item.name,
        document: maskDocument(item.document),
        value: formatMoney(item.value)
      })))
      setHasGroup(true);
    })
  }

  const renderData = () => {
    if (hasGroup) {
      company.companies.map((c, k) => {
        Data.push({
          id: c.id,
          premium: c.premium ? 'Elite' : 'Não Elite',
          name: c.name,
          document: maskDocument(c.document),
          value: c.revenues_total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        });
      });
    }
  }

  function handleUpdateCategory(companyId) {
    setIsSaving(true)
    var formData = new FormData()
    formData.append('new_category', newCategory)

    ResalesRequestService.updateCategory(companyId, formData)
      .then(() => {
        alert.success("Dado Atualizado");
        var _company = {...company}
        _company.ma_category = newCategory
        setCompany(_company)
      })
      .finally(() => setIsSaving(false))
  }

  const columns = [
    {
      dataField: 'premium',
      text: 'Classificação',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'name',
      text: 'Razão Social',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'document',
      text: 'CNPJ',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'value',
      text: 'Faturamento',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  const columnsUsersTable = [
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'email',
      text: 'E-mail',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'profile',
      text: 'Perfil',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'created_at',
      text: 'Data da Criação',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    }, {
      dataField: 'actions',
      text: 'Ações',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    }
  ];

  const setValue = (name, value) => {
    let user_aux = { ...userToSave };
    user_aux[name] = value;
    setUserToSave({ ...user_aux });
  }

  const handleClose = () => {
    Object.keys(userToSave).forEach(key => {
      if (key != "company_id")
        userToSave[key] = ""
    })
    setShowUserModal(false)
  };
  const handleShow = () => setShowUserModal(true);
  const handleDeleteClose = () => setShowUserDeleteModal(false)

  const handleDeleteUser = () => {
    UsersRequestService.delete(userIdToDelete)
      .then(() => {
        setShowUserDeleteModal(false)
        getUsersByCompany()
      })
  }

  const handleSubmitUser = () => {
    var message = ""
    var formData = new FormData()
    formData.append('name', userToSave.name)
    formData.append('lastname', userToSave.lastname)
    formData.append('phone', userToSave.phone ?? "")
    formData.append('alias', userToSave.alias)
    formData.append('profile_id', userToSave.profile_id)
    formData.append('companies[0]', userToSave.company_id)

    var response = null
    if (userToSave.id) {
      message = "Dados Atualizados"
      formData.append('_method', 'put')
      formData.append('id', userToSave.id)
      response = UsersRequestService.update(userToSave.id, formData)
    } else {
      message = "Usuário Cadastrado"
      formData.append('email', userToSave.email)
      response = UsersRequestService.save(formData)
    }

    delete userToSave.action

    response.then(() => {
      setShowUserModal(false)
      getUsersByCompany()
      toast.success(message)
    })
  }

  const handleSaveCompanyProviderCategory = () => {
    var formData = new FormData()
    var hasEmpty = false
    companyProvidersCategory.forEach((item, index) => {
      if (item.category_id == "") {
        hasEmpty = true
        return     
      }

      formData.append(`data[${index}][category_id]`, item.category_id)
      formData.append(`data[${index}][provider_id]`, item.provider_id)
      formData.append(`data[${index}][company_id]`, item.company_id)
    })

    if (hasEmpty) {
      toast.error("Selecione uma categoria para cada um")
      return;
    }

    ResalesRequestService.updateCategory(currentCompany.id, formData)
      .then(_ => {
        toast.success("Atualização de categoria realizada")
      })
  }

  const getCategoryLabel = (provider_id) => {
    const category = companyProvidersCategory.filter(p => p.provider_id == provider_id)[0].category_id;
    switch (category) {
      case 1: 
        return "Master"
      case 2:
        return "Padrão"
      default:
        return "Não definida"
    }
  }

  const formCompany = () => {
    return (
      <>
        <Container>
          <Row className="mt-4">
            <ListAltOutlined className="icon-title" />
            <h5 className="title-dashboard">Dados da Revenda</h5>
          </Row>
          <Row className="">
            <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">

              <Row className="">
                <Col md="12">
                  <h6 className="title-dashboard">Dados cadastrais</h6>
                </Col>
                <Col md="12">
                  <hr className="line"></hr>
                </Col>
              </Row>
              <Row className="">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Grupo:</Form.Label>
                    <Form.Control
                      as="input"
                      disabled={true}
                      value={company.group_name ?? currentCompany.group_name}
                    >
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Razão Social:</Form.Label>
                    <Form.Control
                      as="input"
                      type="text"
                      disabled={true}
                      value={company.name}
                    >
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nome Fantasia:</Form.Label>
                    <Form.Control
                      as="input"
                      disabled={true}
                      value={company.alias}
                    >
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>CNPJ:</Form.Label>
                    <Form.Control
                      as="input"
                      disabled={true}
                      value={maskDocument(company.document)}
                    >
                    </Form.Control>
                  </Form.Group>
                </Col>
                {hasGroup ? 
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Faturamento do Grupo:</Form.Label>
                      <Form.Control
                        as="input"
                        disabled={true}
                        value={company.ranking ? company.ranking.value.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        }) : ''}
                      >
                      </Form.Control>
                    </Form.Group>
                  </Col> 
                :''}

                {/* {company.is_masteragent ? (
                  <Can do="resale.allow-ma-category-edit" on="App">
                    <Col>
                      <Form.Group>
                        <Form.Label>Categoria</Form.Label>
                        <Form.Control
                          as="select"
                          value={newCategory}
                          onChange={(e) => setNewCategory(e.target.value)}
                        >
                          <option selected disabled>Selecione</option>
                          <option value="1">Ouro - Comissão 250%</option>
                          <option value="2">Prata - Comissão 200%</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="12">
                      <Button 
                        disabled={company.ma_category == newCategory}
                        onClick={() => handleUpdateCategory(company.id)}
                      >
                        Salvar {isSaving ? <Spinner animation="border" role="status" size="sm" /> : (<></>)}
                      </Button>
                    </Col>
                  </Can>
                ): (<></>)} */}
{/*</Row>

              {company.is_masteragent ? (
                <Row className="mt-4">
                  <Col md="12" className="d-flex justify-content-between">
                    <h6 className="title-dashboard">Fornecedores / Categoria</h6>
                  </Col>
                  <Col md="12">
                    <hr className="line"></hr>
                  </Col>
                  <Col md="12">
                    <Table size="sm" bordered striped>
                      <thead>
                        <th className='text-center'>#</th>
                        <th className='text-center'>Fornecedor</th>
                        <th className='text-center'>Categoria</th>
                      </thead>
                      <tbody>
                        {company.providers.map(provider => (
                          <tr>
                            <td className='text-center'>{provider.id}</td>
                            <td className='text-center'>{provider.name}</td>
                            <td className='text-center'>
                              {profile.havePermission('resale.allow-ma-category-edit') ? (
                              <Form.Group className='mb-0'>
                                <Form.Control
                                  as="select"
                                  size="sm"
                                  className='mb-0'
                                  value={companyProvidersCategory.filter(p => p.provider_id == provider.id)[0].category_id}
                                  onChange={(e) => {
                                    let items = [...companyProvidersCategory]
                                    const index = items.findIndex((obj => obj.provider_id == provider.id))
                                    items[index].category_id = e.target.value
                                    setCompanyProvidersCategory([...items])
                                  }}
                                >
                                  <option value="" selected disabled>Selecione</option>
                                  <option value="1">Master</option>                      
                                  <option value="2">Padrão</option>
                                </Form.Control>
                              </Form.Group>
                              ):(<>
                                {getCategoryLabel(provider.id)}
                              </>)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {profile.havePermission('resale.allow-ma-category-edit') ? (
                      <Button variant="success" onClick={handleSaveCompanyProviderCategory}>Salvar</Button>):
                    <></>}
                  </Col>
                </Row>
              ): (<></>)}

              <Row className="mt-4">
                <Col md="12" className="d-flex justify-content-between">
                  <h6 className="title-dashboard">Usuários</h6>
                  <Button size='sm' variant="success" onClick={handleShow}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar Usuário
                  </Button>
                </Col>
                <Col md="12">
                  <hr className="line"></hr>
                </Col>
              </Row>
              <Row className="mt-4 col-12">
                <Col md="12">
                  {users.length > 0 ? (
                    <BootstrapTable
                      id="users-table"
                      className="font-10"
                      keyField="id"
                      data={users}
                      columns={columnsUsersTable}
                      bordered
                      striped
                      condensed
                      wrapperClasses={getTamanho(940) ? 'table-responsive' : ''}
                    />
                  ) : (
                    <Alert variant="warning" className="text-center">
                      Sem Usuários
                    </Alert>
                  )}
                </Col>
              </Row>
              <Row className="mt-4">
                <AddressForm company={company} />
              </Row>
              <Row className="mt-4">
                {hasGroup ? (<>
                  <Row className="col-12">
                    <Col md="12">
                      <h6 className="title-dashboard">Faturamento por Revenda</h6>
                    </Col>
                    <Col md="12">
                      <hr className="line"></hr>
                    </Col>
                  </Row>
                  <Col md="12" className="p-0">
                    <BootstrapTable wrapperClasses={getTamanho(940) ? 'table-responsive' : ''} style={{ width: '100px' }}
                      id="table"
                      className="font-10"
                      keyField="id"
                      data={companyGroupList}
                      columns={columns}
                      bordered={false}
                      hover
                      condensed
                    />
                  </Col>
                </>) : ''}
              </Row>
            </Card.Body>
          </Row>
        </Container>
        <Modal
          size='lg'
          backdrop="static"
          keyboard={false}
          centered
          show={showUserModal}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Cadastrar Novo Usuário</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nome:</Form.Label>
                    <Form.Control
                      as="input"
                      onChange={(e) => setValue("name", e.target.value)}
                      value={userToSave.name}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Sobrenome:</Form.Label>
                    <Form.Control
                      as="input"
                      onChange={(e) => setValue("lastname", e.target.value)}
                      value={userToSave.lastname}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <Form.Control
                      as="input"
                      disabled={userToSave.action}
                      onChange={(e) => setValue("email", e.target.value)}
                      value={userToSave.email}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Telefone:</Form.Label>
                    <Form.Control
                      as="input"
                      onChange={(e) => setValue("phone", e.target.value)}
                      value={userToSave.phone}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Apelido:</Form.Label>
                    <Form.Control
                      as="input"
                      onChange={(e) => setValue("alias", e.target.value)}
                      value={userToSave.alias}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Perfil:</Form.Label>
                    <Form.Control
                      as="select"
                      value={userToSave.profile_id}
                      onChange={(e) => {
                        setValue("profile_id", e.target.value)
                      }}
                    >
                      <option value="" selected disabled>Selecione o Perfil</option>
                      {currentCompany.is_premium ? (<>
                        <option value="4">Revenda Master</option>
                        <option value="6">Revenda Gerencial</option>
                        <option value="7">Revenda Visuaizador</option>
                      </>) : (<></>)}
                      {currentCompany.is_masteragent ? (<>
                        <option value="46">Consultor de Negócio</option>
                        <option value="47">Consultor de Negócio</option>
                        <option value="49">Revenda Master Agent</option>
                      </>):(<></>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSubmitUser}>
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>

        
      </>
    );
  };

  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  const showMessageErro = () => {
    return (
      <Unauthorized />
    );
  };

  return (<>{
    currentCompany != null ? formCompany() :
      <>{messageErro ? showMessageErro() : <></>}</>
  }</>);*/
};